<template>
    <div class="kpisWrapper">
        <DashboardKPI v-for="(value, text) in kpis"
                      :key="`${text}_${value}`"
                      :text="text"
                      :value="value"
                      :currency="currency"
        />
    </div>
</template>

<script>
import DashboardKPI from './components/DashboardKPI/DashboardKPI.vue';
import consts from './consts';

export default {
    name: 'DashboardKPIs',
    components: { DashboardKPI },
    props: {
        kpiData: {
            type: Object
        },
        currency: String
    },
    computed: {
        kpis() {
            return Object.entries(this.kpiData).reduce((rowData, [kpi, value]) => {
                const row = { ...rowData };
                const key = consts.kpiPropertyToText[kpi] || '';
                if (key) {
                    row[key] = Number(value);
                }
                return row;
            }, {});
        }
    }
};
</script>

<style scoped lang="scss">
    .kpisWrapper {
        display: grid;
        justify-content: stretch;
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }
</style>
